var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifiedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4994 18.9612C15.2267 18.9612 18.2482 15.6216 18.2482 11.5021C18.2482 7.38252 15.2267 4.04297 11.4994 4.04297C7.77223 4.04297 4.75073 7.38252 4.75073 11.5021C4.75073 15.6216 7.77223 18.9612 11.4994 18.9612Z",
    fill: "url(#paint0_linear_949_616)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M5.46245 17.5375C8.47931 20.5544 13.628 20.2969 16.9625 16.9625C20.2969 13.6281 20.5543 8.47936 17.5375 5.4625C14.5206 2.44564 9.37187 2.70308 6.03745 6.0375C2.70303 9.37192 2.4456 14.5206 5.46245 17.5375Z",
    fill: "url(#paint1_linear_949_616)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7163 9.29527L14.7051 9.14568C14.5995 9.15358 14.4967 9.18286 14.4026 9.23169C14.3086 9.28047 14.2251 9.34775 14.157 9.42943C14.157 9.42952 14.1569 9.42961 14.1568 9.4297L10.4734 13.816L7.67908 12.0433C7.52962 12.1942 7.44511 12.3989 7.44282 12.6124C7.44053 12.8259 7.52063 13.0323 7.66674 13.1865C7.6668 13.1866 7.66685 13.1866 7.66691 13.1867L9.93306 15.588C9.93306 15.588 9.93307 15.588 9.93308 15.588C10.0098 15.6694 10.1025 15.7336 10.2053 15.7765C10.3081 15.8194 10.4186 15.8399 10.5298 15.8366C10.641 15.8333 10.7501 15.8062 10.8502 15.7573C10.9504 15.7084 11.0391 15.6387 11.1111 15.553L11.1111 15.553L15.3649 10.4833C15.5023 10.32 15.5703 10.1082 15.555 9.89442C15.5397 9.68066 15.4422 9.48098 15.2827 9.33968L15.2827 9.33968L15.282 9.33906C15.1226 9.19964 14.9152 9.12972 14.7049 9.1457L14.7163 9.29527ZM14.7163 9.29527C14.631 9.30164 14.5479 9.32529 14.4717 9.36484C14.3954 9.4044 14.3276 9.45908 14.2721 9.52571L14.7163 9.29527Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_949_616",
    x1: 19.3046,
    y1: 2.57903,
    x2: 3.65245,
    y2: 19.6899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030AC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_949_616",
    x1: 25.04,
    y1: 10.5952,
    x2: -1.47882,
    y2: 11.7758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030AC0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIcon);
export default __webpack_public_path__ + "static/media/verified-icon.0292a467d6c3efc23c27cf3b9df4207f.svg";
export { ForwardRef as ReactComponent };